module.exports = __webpack_public_path__ + "img/loja-spmania.09bab261.svg";